<template>
  <!-- <div>
    이름 :<input v-model="tags[0].userName" type="text" /><br /><br />
    이메일 :<input v-model="tags[0].userId" type="text" /> <br /><br />
    이름 :<input v-model="tags[1].userName" type="text" /><br /><br />
    이메일 :<input v-model="tags[1].userId" type="text" /> <br /><br />
    이름 :<input v-model="tags[2].userName" type="text" /><br /><br />
    이메일 :<input v-model="tags[2].userId" type="text" /> <br /><br />
    <button @click="invitationConfirm">확인</button>
    <button @click="closeModal">나가기</button>
  </div> -->
  <div class="modal-window krs015">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("button.member.add.external","외부협력사 멤버 초대") }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="info-txt">
        {{ $i18nUtil.trans("message.InvitationMembers.001","멤버로 가입되어 있지 않은 타사 직원들을 초대할 수 있습니다.") }}
      </div>
      <div class="info-txt smaller">
        {{ $i18nUtil.trans("message.InvitationMembers.002","* 가입 후 90일까지 사용 가능하며, 만료 한달 전 사용 연장 신청이 가능합니다.") }}
      </div>
      <div class="info-txt smaller">
        {{ $i18nUtil.trans("message.InvitationMembers.003","* hanwha.com 도메인 계정은 초대가 아닌 조직도에서 멤버 추가해주세요.") }}
      </div>
      <!-- <ul class="tab-menu">
          <li
            v-for="(tab, index) in tabsTy1"
            v-bind:class="{ active: currentTab1 === index }"
            :key="'tab' + index"
          >
            <button type="button" v-on:click="currentTab1 = index">
              {{ tab }}
            </button>
          </li>
        </ul> -->
      <!-- <div v-show="currentTab1 == 0"> -->
      <div class="tit">{{ $i18nUtil.trans("message.InvitationMembers.004","이메일 초대") }}</div>
      <div class="info-txt small" v-html="$i18nUtil.trans('message.InvitationMembers.005','초대 메일을 통해 과제에 가입하시면 과제 운영자 승인 후 멤버 등록이 완료됩니다.<br /> 이메일 가입 사용자는 과제/보드 조회, 보드 내용 작성/수정, 파일 업로드 등 일부 기능만 사용할 수 있습니다.')">
        <!-- 초대 메일을 통해 {{$i18nUtil.trans("entity.project","과제")}}에 가입하시면 {{$i18nUtil.trans("entity.project","과제")}} 운영자 승인 후 멤버 등록이 완료됩니다.<br /> 이메일 가입 사용자는 {{$i18nUtil.trans("entity.project","과제")}}/보드 조회, 보드 내용 작성/수정, 파일 업로드 등 일부 기능만 사용할 수 있습니다. -->
      </div>
      <div class="tit">{{ $i18nUtil.trans("message.InvitationMembers.006","멤버 정보 입력") }}</div>
      <!-- <button type="button" class="btn_link_add fr" @click="addMember">
                조직도에서 멤버추가
              </button> -->
      <div class="scroll">
        <div class="inner">
          <ul>
            <li v-for="(item, index) in tags" :key="index">
              <button
                v-if="index == 0"
                type="button"
                class="btn_link_add"
                @click="addTags"
              ></button>
              <button
                v-else
                type="button"
                class="btn_link_add del"
                @click="removeTags(index)"
              ></button>
              <div class="input-box">
                <input
                  type="text"
                  required
                  :placeholder="$i18nUtil.trans('message.placeholder.memberName','멤버 이름 입력')"
                  v-model="tags[index].userName"
                />
                <button type="button" class="input-txt-del">입력 삭제</button>
              </div>
              <div class="input-box">
                <input
                  type="email"
                  required
                  :placeholder="$i18nUtil.trans('message.placeholder.email','이메일 주소 입력')"
                  v-model="tags[index].email"
                />
                <button type="button" class="input-txt-del">입력 삭제</button>
              </div>
              <div class="error" v-if="error[index]">
                {{ error[index] }}
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- </div> -->
      <!-- <div v-show="currentTab1 == 1">
            <div class="info-txt small">
              계정 발급 신청 후 계정 생성이 완료되면 멤버로 등록할 수 있습니다.
            </div>
            <footer class="modal-footer">
              <button type="button" class="btn_ty1">
                협력업체 계정 발급 신청
              </button>
            </footer>
          </div> -->
    </div>
    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="invitationConfirm">
        {{ $i18nUtil.trans("button.InvitationMembers.sendMail","초대 메일 보내기") }}
      </button>
    </footer>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import MultiOrg from "@/components/cowork/common/organization/org/MultiOrg";
import EventBus from "@/js/eventbus/eventBus";
export default {
  computed: {
    ...mapState("project", ["projectMemberList"]), // 현재 멤버 리스트
    ...mapState("project", ["projectInvitationMemberList"]), // 현재 초대 멤버 리스트
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isSystemUserCheck: [],
      tags: [{ userName: "", email: "" }],
      error: [],
      currentTab1: 0,
      tabsTy1: [this.$i18nUtil.trans("message.InvitationMembers.004","이메일 초대")],
      invitationMemberList: null,
      invitationCountUser: 0,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  created() {
    EventBus.$off("invitationPopupClose");
    EventBus.$on("invitationPopupClose", () => {
      this.$emit("close");
    });
    EventBus.$off("addInvitationMember");
    EventBus.$on("addInvitationMember", (payload) => {
      console.log("EventBus addInvitationMember", payload);
      for (let i = 0; i < payload.length; i++) {
        if (
          this.tags.length == 1 &&
          this.tags[0].userName == "" &&
          this.tags[0].email == ""
        ) {
          this.tags[this.tags.length - 1].userName = payload[i].userName;
          this.tags[this.tags.length - 1].email = payload[i].email;
          continue;
        }
        this.addTags();
        this.tags[this.tags.length - 1].userName = payload[i].userName;
        this.tags[this.tags.length - 1].email = payload[i].email;
      }
    });
  },
  methods: {
    ...mapActions("modals", ["showToast"]),
    ...mapActions("modals", ["showModal"]),
    ...mapMutations("project", ["setProjectMemberList"]),
    ...mapMutations("project", ["setProjectMemberCount"]),
    ...mapMutations("project", ["setProjectInvitationMemberList"]),
    ...mapMutations("project", ["setProjectInvitationMemberCount"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    async invitationConfirm() {
      let obj = this;
      this.error = [];
      let error = [];
      let isError = false;
      let systemCheck = false;
      this.loader = this.$loading.show();
      // if(this.tags.length == 1 && !this.tags[0].userName && !this.tags[0].email) {

      // }
      for (let i = 0; i < this.tags.length; i++) {
        //이름 byte 체크
        let byte = 0;
        for (let j = 0; j < this.tags[i].userName.length; ++j) {
          // 기본 한글 2바이트 처리
          this.tags[i].userName.charCodeAt(j) > 127 ? (byte += 2) : byte++;
        }

        const key = "error" + i;
        let errorObject = {};
        if (byte > 12) {
          errorObject[key] = this.$i18nUtil.trans("UB048");
          error.push(errorObject);
          if (!isError) {
            isError = true;
          }
        } else if (
          this.tags[i].userName == "" ||
          this.tags[i].userName == null
        ) {
          errorObject[key] = this.$i18nUtil.trans("UB018");
          error.push(errorObject);
          if (!isError) {
            isError = true;
          }
        } else if (this.tags[i].email == "" || this.tags[i].email == null) {
          errorObject[key] = this.$i18nUtil.trans("UB017");
          error.push(errorObject);
          if (!isError) {
            isError = true;
          }
        } else if (
          this.tags[i].email.match(
            /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
          ) == null
        ) {
          errorObject[key] = this.$i18nUtil.trans("UB019");
          error.push(errorObject);
          if (!isError) {
            isError = true;
          }
        } else if (this.tags[i].email.split("@")[1] == "hanwha.com") {
          errorObject[key] = this.$i18nUtil.trans("UB049");
          error.push(errorObject);
          if (!isError) {
            isError = true;
          }
        } else {
          let reqData = {};
          reqData.req = {
            email: this.tags[i].email,
          };
          reqData.url = "/api/auth/isSystemUserCheck";
          reqData.method = "post";
          await obj
            .COWORK_REST_ACTION(reqData)
            .then((res) => {
              if (res.errorCode) {
                console.log(res.errorCode);
              } else {
                if (res.result) {
                  errorObject[key] = obj.$i18nUtil.trans("UB016");
                  error.push(errorObject);
                  isError = true;
                } else {
                  error.push({ key: "" });
                }
              }
            })
            .catch(function (err) {
              console.log(err);
            });
        }
      }
      setTimeout(() => {
        error.sort().forEach((value, index) => {
          obj.error.push(value["error" + index]);
        });
        obj.loader.hide();
        if (isError) {
          const modalInfo = {
            title: this.$i18nUtil.trans("title.InvitationMembers.000","멤버 초대"),
            width: "400px",
            obj: this.$modal,
            contents: this.$i18nUtil.trans("AG046"),
            button: this.$i18nUtil.trans("button.dialog.confirm","확인"),
            component: Dialog,
          };
          this.showModal(modalInfo);
          return;
        }
        const modalInfo = {
          title: this.$i18nUtil.trans("title.InvitationMembers.000","멤버 초대"),
          width: "400px",
          obj: this.$modal,
          contents: this.$i18nUtil.trans("AG048", { userCnt: this.tags.length }),
          button: this.$i18nUtil.trans("button.dialog.send","발송"),
          subButton: this.$i18nUtil.trans("button.dialog.cancel","취소"),
          invitationMemberList: this.tags,
          inviteCount: this.tags.length,
          dialogType: "INVITATION",
          component: Dialog,
        };
        this.showModal(modalInfo);
      }, 800);
    },
    addMember() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.MultiOrg.001","조직도"),
        method: "post",
        width: "1050px",
        // height: "800px",
        obj: this.$modal,
        //orgType: "SINGLE_USER",
        //orgType: "MULTI_USER",
        orgType: "MULTI_ORG",
        memberType: "INVITATION",
        //orgType: "SINGLE_DEPT",
        //orgType: "MULTI_DEPT",
        //component: Organization,
        component: MultiOrg,
        url: "/api/org/getDeptList",
      };
      this.showModal(modalInfo);
    },
    addTags() {
      this.tags.push({ userName: "", email: "" });
    },
    removeTags(index) {
      let tempTags = [];
      let tempError = [];
      for (let i = 0; i < this.tags.length; i++) {
        if (i != index) {
          tempTags.push(this.tags[i]);
          tempError.push(this.error[i]);
        }
      }
      this.tags = tempTags;
      this.error = tempError;
    },
    systemUserCheck(email) {
      let obj = this;
      let returnValue = null;
      let reqData = {};
      reqData.req = {
        email: email,
      };
      reqData.url = "api/auth/isSystemUserCheck";
      reqData.method = "post";
      obj
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            returnValue = res.result;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      return returnValue;
    },
  },
};
</script>
<style scoped>
.select {
  border-bottom: 2px solid orange;
  color: orange;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/InvitationMembers.vue